import { NgModule } from '@angular/core';
import { EventListComponent } from './event-list.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AngularMaterialModule } from '../../angular-material.module';
import { EventItemComponent } from './event-item/event-item.component';
import { CalendarMonthScrollerComponent } from './calendar-month-scroller/calendar-month-scroller.component';
import { SafeStringModule } from '../../pipes/safe-string/safe-string.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AngularMaterialModule,
    SafeStringModule,
    TranslateModule
  ],
  declarations: [
    EventListComponent,
    EventItemComponent,
    CalendarMonthScrollerComponent,
  ],
  providers: [],
  exports: [
    EventListComponent,
  ],
})
export class EventListModule {
}
